import { Extension } from '@tiptap/core';

import { confidenceKey, createConfidencePlugin } from './ConfidencePlugin';
import type { ParagraphConfidenceInfo } from './citation-utils';

export const EditorPlugins = Extension.create({
  name: 'editorPlugins',

  addProseMirrorPlugins() {
    return [createConfidencePlugin()];
  },

  addCommands() {
    return {
      updateConfidenceDecorations:
        (confidences: ParagraphConfidenceInfo[]) =>
        ({ state, dispatch }) => {
          if (dispatch) {
            const tr = state.tr.setMeta(confidenceKey, confidences);
            dispatch(tr);
          }
          return true;
        },
    };
  },
});

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    editorPlugins: {
      updateConfidenceDecorations: (confidences: ParagraphConfidenceInfo[]) => ReturnType;
    };
  }
}
